import { render, staticRenderFns } from "./ProductViewer.vue?vue&type=template&id=19137d45&"
import script from "./ProductViewer.vue?vue&type=script&lang=js&"
export * from "./ProductViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports